import { useEffect, useContext, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { API } from "aws-amplify";
import { useUser } from "../contexts/useUser";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "stripe-pricing-table": any;
    }
  }
}

const PlansAndUpgrade: React.FC = () => {
  const { project, user, subscriptionActive } = useUser();
  const [portalUrl, setPortalUrl] = useState<string | null>(null);

  const hasLocalhost = (hostname: any) =>
    Boolean(
      hostname.match(/localhost/) ||
        hostname.match(
          /127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/
        ) ||
        hostname.match(/dev.llmasaservice.io/)
    );

  const isDevMode = hasLocalhost(window.location.hostname);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const openUrlInNewPage = (url: string) => {
    window.open(url, "_blank");
  };

  const openBillingPortal = async () => {
    if (!project?.stripeCustomerId) {
      return;
    }

    try {
      const portal = await API.post("eventapi", "/customerPortal", {
        body: {
          customerId: project?.stripeCustomerId,
          returnUrl: window.location.href,
        },
      });

      if (portal) {
        openUrlInNewPage(portal.url);
      }
    } catch (error) {
      console.error("Error getting stripe portal URL.", error as any);
    }
  };

  return (
    <Box>
      {subscriptionActive ? (
        <Box textAlign="center">
          <Box textAlign="center">
            <Typography variant="h6">Your subscription is active.</Typography>

            <Typography variant="body1">
              Your subscription{" "}
              {project?.subscription?.subscriptionCancelAtPeriodEnd === "true"
                ? "cancels"
                : "renews"}{" "}
              on{" "}
              {new Date(
                project?.subscription?.subscriptionEndDate as string
              ).toLocaleDateString()}
              .<br />
              <br />
            </Typography>

            <Typography variant="body2">
              You can download invoices and manage your subscription below.
              <br />
              <br />
            </Typography>
          </Box>

          <Button variant="contained" onClick={() => openBillingPortal()}>
            Download Invoices, Manage Plan (opens in new window)
          </Button>
        </Box>
      ) : isDevMode ? (
        <Box textAlign="center">
          <Typography variant="h6">Upgrade your subscription?</Typography>

          {project?.subscription?.subscriptionStatus === "canceled" ? (
            <Typography variant="body2" padding={2} margin={2}>
              You were a subscriber but your subscription has expired. We
              hope to win you back as a customer by subscribing again below.
              <br />
              If you want to see/download your prior invoices and receipts, you
              can view them here.
              <br />
              <br />
              <Button variant="contained" onClick={() => openBillingPortal()}>
                Download Invoices (opens in new window)
              </Button>
            </Typography>
          ) : (
            <Typography variant="body2">
              After the initial trial period, you can upgrade your subscription
              to a paid plan. <br />
              You can upgrade, downgrade or cancel at any time (cancel occurs at
              the end of the current paid subscription period).
              <br /> We use Stripe as our payment partner which securely store
              and process all of your transactions.
              <br />
              <br />
            </Typography>
          )}

          <stripe-pricing-table
            pricing-table-id="prctbl_1QMyfuEdD4cC8YS7yvQhehLx"
            publishable-key="pk_test_51QKOOSEdD4cC8YS7oFROu80NJ3E5Rd4DKEQUyOtkLaZy1Rv6CZt2ToRqCBwfpRxTREvlc2u0aIhBS4wWExzGj3Hi00ZwFVdkCI"
            client-reference-id={project?.id}
            customer-email={user?.email}
          ></stripe-pricing-table>
        </Box>
      ) : (
        <Box textAlign="center">
          <Typography variant="h6">Upgrade your subscription?</Typography>

          {project?.subscription?.subscriptionStatus === "canceled" ? (
            <Typography variant="body2" padding={2} margin={2}>
              You were a subscriber but your subscription has expired. We
              hope to win you back as a customer by subscribing again below.
              <br />
              If you want to see/download your prior invoices and receipts, you
              can view them here.
              <br />
              <br />
              <Button variant="contained" onClick={() => openBillingPortal()}>
                Download Invoices (opens in new window)
              </Button>
            </Typography>
          ) : (
            <Typography variant="body2">
              After the initial trial period, you can upgrade your subscription
              to a paid plan. <br />
              You can upgrade, downgrade or cancel at any time (cancel occurs at
              the end of the current paid subscription period).
              <br /> We use Stripe as our payment partner which securely store
              and process all of your transactions.
              <br />
              <br />
            </Typography>
          )}
          <stripe-pricing-table
            pricing-table-id="prctbl_1QS3ZGEdD4cC8YS7bdP9CJx9"
            publishable-key="pk_live_51QKOOSEdD4cC8YS7oe7hLnDkFkqbwiqS3iKGgR4B0qlTzER7HftlR5EXMMEBKwqdDW7nLCD8RCJxqDq1uNd8C2Zf00S0nC1tHA"
            client-reference-id={project?.id}
            customer-email={user?.email}
          ></stripe-pricing-table>
        </Box>
      )}
    </Box>
  );
};

export default PlansAndUpgrade;
